import React from 'react'
import Aside from '../../Components/aside'
import IncludedfulltextComponent from '../../Components/IncludedFulltextComponent'
import TopBar from '../../Components/topBar'
import { SnackbarProvider } from "notistack";

const IncludedFulltext = () => {
  return (
    <SnackbarProvider>
    <div className="main-wrapper">
      <div className="content-wrapper">
        <IncludedfulltextComponent />
      </div>
    </div>
    </SnackbarProvider>

  )
}

export default IncludedFulltext